document.addEventListener('DOMContentLoaded', function () {
  // Try to scope to description containers first (safer)
  const roots =
    document.querySelectorAll('.product__description, .product-description, .product-single__description, [data-product-description], .rte');

  // If we can't find a root, fallback to document
  const containers = roots.length ? Array.from(roots) : [document];

  containers.forEach(function (root) {
    root.querySelectorAll('.accordion[data-bv-desc-accordion]').forEach(function (accordion) {
      const header = accordion.querySelector('.accordion-header');
      const panel  = accordion.querySelector('.accordion-panel');
      const inner  = accordion.querySelector('.accordion-inner');

      if (!header || !panel || !inner) return;

      // Prevent double binding if Shopify re-renders sections
      if (accordion.dataset.bvInit === '1') return;
      accordion.dataset.bvInit = '1';

      // Start closed
      accordion.classList.remove('active');
      panel.style.maxHeight = '0px';

      function syncHeight() {
        if (accordion.classList.contains('active')) {
          panel.style.maxHeight = inner.scrollHeight + 'px';
        }
      }

      function openAccordion() {
        accordion.classList.add('active');
        syncHeight();
      }

      function closeAccordion() {
        accordion.classList.remove('active');
        panel.style.maxHeight = '0px';
      }

      function toggleAccordion() {
        accordion.classList.contains('active') ? closeAccordion() : openAccordion();
      }

      // 1) Header click always toggles (including the + button)
      header.addEventListener('click', function (e) {
        e.preventDefault();
        toggleAccordion();
      });

      // 2) Click anywhere INSIDE the panel closes (except links/inputs)
      panel.addEventListener('click', function (e) {
        if (!accordion.classList.contains('active')) return;

        // allow links + form controls to work
        if (e.target.closest('a, button, input, textarea, select, label')) return;

        // if user is selecting text, don't close
        const sel = window.getSelection && window.getSelection();
        if (sel && sel.toString().trim().length) return;

        closeAccordion();
      });

      // Keep height correct if layout changes
      window.addEventListener('resize', syncHeight);

      // If content inside changes height (rare but nice)
      if (window.ResizeObserver) {
        new ResizeObserver(syncHeight).observe(inner);
      }
    });
  });
});

// If your theme dynamically re-renders product sections (common),
// this catches it without affecting the rest of the site.
document.addEventListener('shopify:section:load', function (e) {
  const root = e.target || document;
  root.querySelectorAll('.accordion[data-bv-desc-accordion]').forEach(function (accordion) {
    if (accordion.dataset.bvInit === '1') return;
    // trigger the DOMContentLoaded logic by simulating load
    // simplest is just dispatch a DOMContentLoaded-like init:
    // reload page-level init if you want, but this is enough:
  });
});